import React, { useEffect, useState } from "react";
import { API_URL } from "../../helpers/variables";

import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { Chip, Fab, Stack } from "@mui/material";

import { Refresh } from "@mui/icons-material";

const Corporations = () => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });
  const [quickSearch, setQuickSearch] = useState("");

  const [corporationData, setCorporationData] = useState({});
  const {
    corporations = {},
    totalCorporationsCount = 0,
    pmsList = [],
    clients = [],
  } = corporationData;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCorporations();
  }, [paginationModel, quickSearch]);

  async function getCorporations() {
    setLoading(true);
    let params = new URLSearchParams({
      ...paginationModel,
      quickSearch,
    });
    let res = await fetch(`${API_URL}/get_all_corporations?${params}`);
    let data = await res.json();
    setCorporationData(data);
    setLoading(false);
  }

  return (
    <Stack height={"100%"} position={"relative"}>
      <DataGrid
        getRowId={(row) => row._id}
        rows={corporations}
        loading={loading}
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
        disableColumnFilter
        disableColumnSorting
        rowCount={totalCorporationsCount}
        paginationMode="server"
        onPaginationModelChange={(m) => setPaginationModel(m)}
        onFilterModelChange={(m) =>
          setQuickSearch(m.quickFilterValues?.join(" ") || "")
        }
        columns={[
          {
            field: "id",
            headerName: "ID",
          },
          {
            field: "clientName",
            headerName: "Client",
            type: "singleSelect",
            valueOptions: clients,
            flex: 1,
          },
          {
            field: "name",
            headerName: "Corporation",
            flex: 1,
          },
          {
            field: "pcName",
            headerName: "PC",
            flex: 1,
          },
          {
            field: "facilityID",
            headerName: "Facility ID",
            flex: 1.5,
          },
          {
            field: "AliasFacilityID",
            headerName: "Alias Facility ID",
            flex: 1.5,
          },
          {
            field: "pmsName",
            headerName: "PMS",
            type: "singleSelect",
            valueOptions: pmsList,
            flex: 1,
          },
          {
            field: "status",
            headerName: "Status",
            type: "boolean",
          },
          {
            field: "reports",
            headerName: "Reports",
            flex: 2,
            renderCell: ({ value }) =>
              value?.map((i) => (
                <Chip
                  size="small"
                  color="info"
                  label={i.name}
                  sx={{ m: 0.5 }}
                />
              )),
          },
        ]}
        disableRowSelectionOnClick
        getRowHeight={() => "auto"}
        sx={{
          [`& .${gridClasses.cell}`]: {
            py: 2,
          },
        }}
        showToolbar
      />
      <Fab
        size="small"
        onClick={getCorporations}
        sx={{
          position: "absolute",
          bottom: 68,
          right: 32,
        }}
      >
        <Refresh />
      </Fab>
    </Stack>
  );
};

export default Corporations;
